import { render } from "./InvestorLeaderBoard.vue?vue&type=template&id=1df8d02c"
import script from "./InvestorLeaderBoard.vue?vue&type=script&lang=js"
export * from "./InvestorLeaderBoard.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/digiasia.asia.bak/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__